import {UPDATE_MESSAGE_VALUE, EMOJI_CLICK} from '../actions';
import typingIndicator from '../services/typingIndicator';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';

export default function message(state = '', action) {
  switch (action.type) {
    case UPDATE_MESSAGE_VALUE:
      return action.value;
    case EMOJI_CLICK:
      return state + action.emoji;
    default:
      return state;
  }
}

const stopTypingScheduler = debounce(typingIndicator.stopTyping.bind(typingIndicator), 3000);

export const notifyTypingStatus = message => {
  if (!isEmpty(message) && !typingIndicator.isCurrentUserTyping) {
    typingIndicator.startTyping();
    stopTypingScheduler();
  } else if (!isEmpty(message) && typingIndicator.isCurrentUserTyping) {
    stopTypingScheduler(); //postpone debounce
  } else if (typingIndicator.isCurrentUserTyping && isEmpty(message)) {
    stopTypingScheduler.flush();
  }
};



// WEBPACK FOOTER //
// ./chat-app/reducers/message.js